<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar :title="numerovenda" exibeVoltar="true" historyback="true" />
        </div>
		<div class="app-centro-sem-rodape">
            <div class="lista-venda">
                <div class="item-lista">
                    <div class="label">Data Lct.</div>
                    <div>{{ venda.DATA_LCT | moment("DD/MM/YYYY") }}</div>
                </div>
                <div class="item-lista">
                    <div class="label">Produto</div>
                    <div>{{ venda.COD_PRODUTO }}</div>
                </div>
                <div class="item-lista">
                    <div class="label">Fop</div>
                    <div>{{ venda.FOP }}</div>
                </div>
                <div class="item-lista">
                    <div class="label">Tipo D/I</div>
                    <div v-if="venda.TIPO_DRI=='D'">Doméstico</div>
                    <div v-if="venda.TIPO_DRI=='I'">Internacional</div>
                </div>
                <div class="item-lista">
                    <div class="label">Fornecedor</div>
                    <div>{{ venda.CTA_FORNECEDOR }}</div>
                </div>
                <div class="item-lista">
                    <div class="label">Cia</div>
                    <div>{{ venda.CIA }}</div>
                </div>
                <div class="item-lista">
                    <div class="label">Form/Nr.Doc</div>
                    <div>{{ venda.FORM }}{{ venda.NR_DOC }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TARIFA>0">
                    <div class="label">Tarifa à Vista/Fat</div>
                    <div>{{ venda.VL_TARIFA | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TAXA_BR>0">
                    <div class="label">Taxa à Vista/Fat.</div>
                    <div>{{ venda.VL_TAXA_BR | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TI_VISTA>0">
                    <div class="label">Du à Vista/Fat.</div>
                    <div>{{ venda.VL_TI_VISTA | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS1_VISTA>0">
                    <div class="label">Outras Txs.(1) à Vista/Fat.</div>
                    <div>{{ venda.OUTRAS_TXS1_VISTA | toCurrency }}</div>
                </div>


                <div class="item-lista" v-if="venda.OUTRAS_TXS2_VISTA>0">
                    <div class="label">Outras Txs.(2) à Vista/Fat.</div>
                    <div>{{ venda.OUTRAS_TXS2_VISTA | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS3_VISTA>0">
                    <div class="label">Outras Txs.(3) à Vista/Fat.</div>
                    <div>{{ venda.OUTRAS_TXS3_VISTA | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TARIFA_DF>0">
                    <div class="label">Tarifa Cartão/Ch.Forn.</div>
                    <div>{{ venda.VL_TARIFA_DF | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TAXA_DF>0">
                    <div class="label">Taxa Cartão/Ch.Forn.</div>
                    <div>{{ venda.VL_TAXA_DF | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TI_DF>0">
                    <div class="label">Du Cartão/Ch.Forn.</div>
                    <div>{{ venda.VL_TI_DF | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TI_DF_TX_CARTAO>0">
                    <div class="label">Tx. Cartão Du</div>
                    <div>{{ venda.VL_TI_DF_TX_CARTAO | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS1_DF>0">
                    <div class="label">Outras Txs.(1) Cartão/Ch.Forn.</div>
                    <div>{{ venda.OUTRAS_TXS1_DF | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS2_DF>0">
                    <div class="label">Outras Txs.(2) Cartão/Ch.Forn.</div>
                    <div>{{ venda.OUTRAS_TXS2_DF | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS3_DF>0">
                    <div class="label">Outras Txs.(3) Cartão/Ch.Forn.</div>
                    <div>{{ venda.OUTRAS_TXS3_DF | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TARIFA_CARTAO>0">
                    <div class="label">Tarifa Cartão (MP)</div>
                    <div>{{ venda.VL_TARIFA_CARTAO | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TAXA_BR_CARTAO>0">
                    <div class="label">Taxa Cartão (MP)</div>
                    <div>{{ venda.VL_TAXA_BR_CARTAO | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_TI_CARTAO>0">
                    <div class="label">Du Cartão (MP)</div>
                    <div>{{ venda.VL_TI_CARTAO | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS1_CARTAO>0">
                    <div class="label">Outras Txs.(1) Cartão (MP)</div>
                    <div>{{ venda.OUTRAS_TXS1_CARTAO | toCurrency }}</div>
                </div>
                <div class="item-lista" v-if="venda.OUTRAS_TXS2_CARTAO>0">
                    <div class="label">Outras Txs.(2) Cartão (MP)</div>
                    <div>{{ venda.OUTRAS_TXS2_CARTAO | toCurrency }}</div>
                </div>
                <div class="item-lista" v-if="venda.OUTRAS_TXS3_CARTAO>0">
                    <div class="label">Outras Txs.(3) Cartão (MP)</div>
                    <div>{{ venda.OUTRAS_TXS3_CARTAO | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS1_ID_TX">
                    <div class="label">Código Outras Tx.(1)</div>
                    <div>{{ venda.OUTRAS_TXS1_ID_TX }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS2_ID_TX">
                    <div class="label">Código Outras Tx.(2)</div>
                    <div>{{ venda.OUTRAS_TXS2_ID_TX }}</div>
                </div>

                <div class="item-lista" v-if="venda.OUTRAS_TXS3_ID_TX">
                    <div class="label">Código Outras Tx.(3)</div>
                    <div>{{ venda.OUTRAS_TXS3_ID_TX }}</div>
                </div>

                <div class="item-lista" v-if="venda.CTA_CARTAO">
                    <div class="label">Cartão (MP)</div>
                    <div>{{ venda.CTA_CARTAO }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_CARTAO">
                    <div class="label">Vct (MP)</div>
                    <div>{{ venda.VCT_CARTAO | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_COMISS_CARTAO>0">
                    <div class="label">Vlr. Custas (MP)</div>
                    <div>{{ venda.VL_COMISS_CARTAO | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.CTA_CP">
                    <div class="label">Cartão (CP)</div>
                    <div>{{ venda.CTA_CP }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_CP">
                    <div class="label">Vct (CP)</div>
                    <div>{{ venda.VCT_CP | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.TARIFA_Y>0">
                    <div class="label">Full Fare</div>
                    <div>{{ venda.TARIFA_Y | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.BEST_FARE>0">
                    <div class="label">Best Fare</div>
                    <div>{{ venda.BEST_FARE | toCurrency }}</div>
                </div>
                <div class="item-lista" v-if="venda.VL_MARKUP>0">
                    <div class="label">Markup</div>
                    <div>{{ venda.VL_MARKUP | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_COMISS_AG>0">
                    <div class="label">Comissão</div>
                    <div>{{ venda.VL_COMISS_AG | toCurrency }}</div>
                </div>
                <div class="item-lista" v-if="venda.VL_OVER_AG>0">
                    <div class="label">Over</div>
                    <div>{{ venda.VL_OVER_AG | toCurrency }}</div>
                </div>
                <div class="item-lista" v-if="venda.VL_ISS_FORNEC>0">
                    <div class="label">Iss</div>
                    <div>{{ venda.VL_ISS_FORNEC | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_FORN_MASTER_FORNECEDOR">
                    <div class="label">Vct. Fornecedor</div>
                    <div>{{ venda.VCT_FORN_MASTER_FORNECEDOR | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.CTA_CLIENTE">
                    <div class="label">Cliente</div>
                    <div>{{ venda.CTA_CLIENTE }}</div>
                </div>

                <div class="item-lista" v-if="venda.COD_CCUSTO_CLIENTE">
                    <div class="label">C.Custos/Cli</div>
                    <div>{{ venda.COD_CCUSTO_CLIENTE }}</div>
                </div>
                <div class="item-lista" v-if="venda.VL_DESCONTO_CLI>0">
                    <div class="label">Desconto</div>
                    <div>{{ venda.VL_DESCONTO_CLI | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_CLI_MASTER">
                    <div class="label">Vct. Cliente</div>
                    <div>{{ venda.VCT_CLI_MASTER | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.NR_REQ">
                    <div class="label">Nr. Req.</div>
                    <div>{{ venda.NR_REQ }}</div>
                </div>
                <div class="item-lista" v-if="venda.VL_COMISS_CLI>0">
                    <div class="label">Comiss. Ag/Cli.</div>
                    <div>{{ venda.VL_COMISS_CLI | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_CLI_COMISSAO">
                    <div class="label">Vct. Comiss. Ag/Cli.</div>
                    <div>{{ venda.VCT_CLI_COMISSAO | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.CTA_EMISSOR">
                    <div class="label">Emissor</div>
                    <div>{{ venda.CTA_EMISSOR }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_COMISS_EMISSOR>0">
                    <div class="label">Comiss. Emissor</div>
                    <div>{{ venda.VL_COMISS_EMISSOR | toCurrency }}</div>
                </div>


                <div class="item-lista" v-if="venda.VL_OVER_EMISSOR>0">
                    <div class="label">Over Emissor</div>
                    <div>{{ venda.VL_OVER_EMISSOR | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_EMISSOR_PAGAR">
                    <div class="label">Vct. Emissor</div>
                    <div>{{ venda.VCT_EMISSOR_PAGAR | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.CTA_PROMOTOR">
                    <div class="label">Promotor</div>
                    <div>{{ venda.CTA_PROMOTOR }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_COMISS_PROMOTOR>0">
                    <div class="label">Over Promotor</div>
                    <div>{{ venda.VL_COMISS_PROMOTOR | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_PROMOTOR_PAGAR">
                    <div class="label">Vct. Promotor</div>
                    <div>{{ venda.VCT_PROMOTOR_PAGAR | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.CTA_GERENTE">
                    <div class="label">Gerente</div>
                    <div>{{ venda.CTA_GERENTE }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_COMISS_GERENTE>0">
                    <div class="label">Over Gerente</div>
                    <div>{{ venda.VL_COMISS_GERENTE | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_GERENTE_PAGAR">
                    <div class="label">Vct. Gerente</div>
                    <div>{{ venda.VCT_GERENTE_PAGAR | moment("DD/MM/YYYY")  }}</div>
                </div>

                <div class="item-lista" v-if="venda.PAX1">
                    <div class="label">Pax</div>
                    <div>{{ venda.PAX1 }}</div>
                </div>

                <div class="item-lista" v-if="venda.RLOC">
                    <div class="label">Localizador</div>
                    <div>{{ venda.RLOC }}</div>
                </div>

                <div class="item-lista" v-if="venda.ORIGEM_CAPTACAO">
                    <div>Canal Captação</div>
                    <div>{{ venda.ORIGEM_CAPTACAO }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_KANDIR_TARIFA>0">
                    <div class="label">Kandir Tarifa</div>
                    <div>{{ venda.VL_KANDIR_TARIFA | toCurrency }}</div>
                </div>

                <div class="item-lista" v-if="venda.VL_KANDIR_TX>0">
                    <div class="label">Kandir Taxa</div>
                    <div>{{ venda.VL_KANDIR_TX | toCurrency }}</div>
                </div>
                
                <div class="item-lista" v-if="venda.VCT_KANDIR_TARIFA">
                    <div class="label">Vct. Kandir</div>
                    <div>{{ venda.VCT_KANDIR_TARIFA | moment("DD/MM/YYYY")  }}</div>
                </div>
                
 
                <div class="item-lista" v-if="venda.ROTA_COMPLETA">
                    <div class="label">Rota</div>
                    <div>{{ venda.ROTA_COMPLETA }}</div>
                </div>

                <div class="item-lista" v-if="venda.INFO_ADCS">
                    <div class="label">Inf. Adc.</div>
                    <div>{{ venda.INFO_ADCS }}</div>
                </div>

            </div>      
        </div>
	</div>



    
</template>


<script>

import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';

export default {
    name: 'MapaProducaoVisualizaVenda',
    props : ["id_vs"],
    components : {TopBar},

    data(){
        return {
            venda : {}
        }
    },
    mounted(){
        request(this, 'GET',
            'Mobile_GetVenda',
            `id_filial=${this.$root.getFilial()}&id_usuario=${this.$root.getUsuario()}&id_vs=${this.id_vs}&rootProperty=venda`)
            .then(res => {
                if(res){
                    this.venda = res.venda;
                }
            });        
    },
    computed:{
        numerovenda: function() {
            if(this.venda.ID_VS)
            return 'Venda ' + this.venda.ID_VS;
            else 
            return 'Venda';
        }
    }

}
</script>

<style scoped>

    .item-lista{

        display: table !important;
        line-height: unset;

    }



    .item-lista div {
        float: left;
        display: table-cell; vertical-align: middle;
    }

    .label{
        width: 40%;
        font-weight: bold;
    }

    .lista-venda{
        overflow-x: hidden;
        overflow-y: auto;
        height: calc(100vh - 70px);
    }

</style>